import api from "../common/api";

const getAll = () => api.get("universidade/integracao/venda");

const get = (id) => api.get(`universidade/integracao/venda/${id}`);

const create = () => api.post("universidade/integracao/venda");

const update = (id, data) =>
  api.put(`universidade/integracao/venda/${id}`, data);

const addVideo = (id, data) =>
  api.put(`universidade/integracao/venda/${id}/video`, data);

const addArquivo = (id, data) =>
  api.put(`universidade/integracao/venda/${id}/arquivo`, data);

const remove = (id) => api.delete(`universidade/integracao/venda/${id}`);

const removeVideo = (id, idVideo) =>
  api.delete(`universidade/integracao/venda/${id}/video/${idVideo}`);

const removeArquivo = (id, idArquivo) =>
  api.delete(`universidade/integracao/venda/${id}/arquivo/${idArquivo}`);

const universidadeIntegracaoVendasService = {
  getAll,
  get,
  create,
  update,
  addVideo,
  addArquivo,
  remove,
  removeVideo,
  removeArquivo,
};

export default universidadeIntegracaoVendasService;
